// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__jY5E7","formGroup":"LoginPage_formGroup__M0YmS"};